import type React from 'react';

import { Button } from '@change/ds-core-ui';
import { ShareIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import type { UseMobileNativeShareReturn } from '#src/app/pages/petitionDetails/shared/hooks';

type Props = {
	shareAction: UseMobileNativeShareReturn;
};

/**
 * Fires the same OS native share sheet as the hero-photo `NativeShareMobile` FAB — no modal,
 * no `useMobileModalContext`, no `ShareEducationModalProvider`, since the native-share path needs
 * none of them. `shareAction` is resolved once by the caller and passed down here, rather than
 * re-derived via a second `useMobileNativeShare` call with the same tracking context.
 */
export const SignCtaShareAffordance: React.FC<Props> = ({ shareAction }) => {
	// Render nothing when the resolved share action is unavailable — never a dead button.
	if (!shareAction) {
		return null;
	}

	const { ShareAction } = shareAction;

	return (
		<ShareAction>
			<Button
				leadingIcon={<ShareIcon />}
				variant="secondary"
				size="large"
				data-qa="sign-cta-share-affordance"
				data-testid="sign-cta-share-affordance"
				className="w-full max-w-none"
			>
				<Translate value="fe.components.petition_share.action" />
			</Button>
		</ShareAction>
	);
};
